import { render, staticRenderFns } from "./lyckat-samarbete-mellan-gritify-och-dagens-industri.vue?vue&type=template&id=d730dac8&"
import script from "./lyckat-samarbete-mellan-gritify-och-dagens-industri.vue?vue&type=script&lang=ts&"
export * from "./lyckat-samarbete-mellan-gritify-och-dagens-industri.vue?vue&type=script&lang=ts&"
import style0 from "./lyckat-samarbete-mellan-gritify-och-dagens-industri.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./lyckat-samarbete-mellan-gritify-och-dagens-industri.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
